import initial from '../store/initial.js'

import {} from '../actions'

function ui (uiState = initial.ui, action) {
  return uiState
}

export default ui
